<template>
  <section v-if="contextData">
    <div class="container-wrap py-9 tablet:py-12">
      <div class="desktop:flex">
        <div class="desktop:mr-6 desktop:w-1/3">
          <h2 class="text-solution-h2 mb-2 tablet:line-clamp-2">
            {{ contextData.title }}
          </h2>
          <p
            class="mb-6 w-full text-sm text-gray-600 tablet:line-clamp-6 tablet:text-base"
          >
            {{ contextData.description }}
          </p>
        </div>
        <ul class="desktop:w-2/3">
          <li
            v-for="(item, index) in contextItems"
            :key="hash(item)"
            class="w-full border-b border-solid border-gray-400"
          >
            <SuiteFaqCard
              :item-data="item"
              :item-index="index"
              :url-connector="urlConnector"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description?: string;
  }

  interface IFaqData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IFaq {
    component: 'faq';
    meta: {
      navigable?: string;
    };
    data: IFaqData;
  }

  type IProps = ISuiteProps<IFaq>;

  const props = defineProps<IProps>();

  const contextData = computed((): IFaqData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  export type { IFaq, IFaqData, IItem };
</script>
